var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnTableCellPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4343 4.5655C15.2526 4.38461 15.0369 4.2415 14.7996 4.14444C14.5623 4.04739 14.3082 3.99831 14.0518 4.00004C13.7954 4.00178 13.5419 4.05429 13.306 4.15455C13.07 4.25481 12.8563 4.40083 12.6771 4.58417L4.94397 12.3173L4 15.9998L7.68255 15.0553L15.4157 7.32222C15.599 7.1431 15.7451 6.9294 15.8454 6.69348C15.9457 6.45756 15.9982 6.2041 16 5.94775C16.0017 5.69141 15.9526 5.43726 15.8555 5.2C15.7584 4.96275 15.6153 4.74709 15.4343 4.5655V4.5655Z",
    stroke: "#172664",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4561 4.80566L15.1941 7.54371",
    stroke: "#172664",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.94434 12.3164L7.68505 15.0523",
    stroke: "#172664",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnTableCellPencil);
export default __webpack_public_path__ + "static/media/icn_table_cell_Pencil.8aa69b11ae7a99494e26310667e65d69.svg";
export { ForwardRef as ReactComponent };